export default function placeFeed() {
  return {
    _id: false,
    type: 'droplet.placeFeed',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    sort: 'newest',
    filters: [],
    match: 'all',
    itemCount: 3,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/place-feed/droplet.schema.js